module.exports = __webpack_public_path__ + "img/C73451.984196e4.png";